export const STORE_KEY = '@@agreements'
export const GET_TERMS_AND_CONDITIONS_REQUEST = `${STORE_KEY}/GET_TERMS_AND_CONDITIONS_REQUEST`
export const GET_TERMS_AND_CONDITIONS_SUCCESS = `${STORE_KEY}/GET_TERMS_AND_CONDITIONS_SUCCESS`
export const GET_TERMS_AND_CONDITIONS_FAILURE = `${STORE_KEY}/GET_TERMS_AND_CONDITIONS_FAILURE`
export const GET_PRIVACY_POLICY_REQUEST = `${STORE_KEY}/GET_PRIVACY_POLICY_REQUEST`
export const GET_PRIVACY_POLICY_SUCCESS = `${STORE_KEY}/GET_PRIVACY_POLICY_SUCCESS`
export const GET_PRIVACY_POLICY_FAILURE = `${STORE_KEY}/GET_PRIVACY_POLICY_FAILURE`
